export const LANG_DE_NAME = 'de';

export const LANG_DE_TRANS = {
    login: 'Einloggen',
    selectLanguage: 'Sprache wählen',
    profileChoose: 'Bitte wählen Sie die Fachrichtung und Ihre Sprache',
    speciality: 'Fachrichtung',
    language: 'Sprache',
    saveAndContinue: 'Speichern und Fortfahren',
    capitalChoose: 'Kapitel auswählen',
    questions: 'FRAGEN',
    question: 'Frage',
    dashboard: 'ÜBERSICHT',
    logout: 'Abmelden',

    //Question buttons
    previous: 'Zurück',
    next: 'Weiter',
    finish: 'Abschliessen',
    checkAnswer: 'Antwort überprüfen',
    source: 'Quelle:',

    //Dashboard
    trackStatictics: 'Verfolgen sie Ihre statistik',
    correct: 'Richtig',
    wrong: 'Falsch',
    unanswered: 'Unbeantwortet',
    percentCorrect: '% richtig',
    capital: 'Kapitel',
    total: 'Gesamt',
    practiceFailed: 'Falsch beantwortete Fragen kreuzen',
    practiceUnanswered: 'Nicht beantwortete Fragen kreuzen',
    resetQuestions: 'Alle Antworten zurücksetzen',
    resetQuestionNotification: 'Ihre Antworten wurden zurückgesetzt.',
    resetNoQuestionNotification: 'Sie haben keine Fragen zum Zurücksetzen',
    yes: 'Ja',
    no: 'Nein',
    resetConfirmMessage: 'Möchten Sie wirklich alle Ihre Antworten löschen?',
    wrongQuestionNotification: 'Sie haben keine falschen Fragen.',
    unansweredQuestionNotification: 'Sie haben keine unbeantworteten Fragen.',
    anyQuestionNotification: 'Sie haben keine Fragen mehr',

    //Login
    emailValidError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    emailRequiredError: 'Bitte geben Sie Ihr E-Mail-Adresse ein',
    passwordInputError: 'Bitte geben Sie Ihr Passwort ein',
    password: 'Passwort',
    email: 'E-Mail Adresse',
    forgotPassword: 'Passwort Vergessen',


    //Forgot Password component
    passwordRecovery: 'Passwort-Wiederherstellung',
    enterEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen ein neues Passwort zu',
    send: 'Senden',
    forgotEmail: 'E-Mail-Adresse vergessen',
    checkEmail: 'Check deine E-Mail-Adresse',
    checkEmailMessage: 'Wir haben Ihnen eine E-Mail gesendet. Bitte überprüfen Sie diese, um Ihr Passwort zurückzusetzen.',
    returnLogin: 'Zurück zur Anmeldung',
    contactMessage1: 'Sie können uns unter ',
    contactEmail: 'support@medexam.app',
    contactMessage2:' kontaktieren, um Ihre registrierte E-Mail-Adresse wiederherzustellen.',
    noSendEmail: 'E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.',
    setNewPassword: 'Neues Passwort festlegen',
    setNewPasswordHint: 'Geben Sie ein neues Passwort für Ihr Konto ein.',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    passwordMismatch: 'Die Passwörter stimmen nicht überein',
    savePassword: 'Passwort speichern',
    resetPasswordSuccess: 'Ihr Passwort wurde aktualisiert. Sie können sich jetzt anmelden.',
    resetPasswordError: 'Dieser Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.',

    correctPercentage: 'Richtiger Prozentsatz',

    // Guest demo
    demoTitle: 'Teste 10 kostenlose Fragen',
    demoIntro: 'Beantworte 10 Übungsfragen ohne Registrierung oder Bezahlung. Der vollständige Fragenkatalog bleibt nach dem Kauf verfügbar.',
    demoStart: 'Demo starten',
    demoContinue: 'Demo fortsetzen',
    demoFreeQuestions: 'Teste 10 kostenlose Fragen',
    demoLoginLink: 'Einloggen',
    demoBadge: 'Kostenlose Demo',
    demoOf: 'von',
    demoFallbackNotice: 'Beispielfragen, weil die Gast-API noch nicht verfügbar ist.',
    demoUnavailable: 'Die Demo ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.',
    demoFinishedTitle: 'Demo beendet',
    demoFinishedLead: 'Du hast deine 10 kostenlosen Fragen genutzt. Schalte den vollständigen Fragenkatalog frei, um weiter zu üben.',
    demoScoreCaption: 'richtige Antworten',
    demoPurchaseCta: 'Prüfungsfragen kaufen',
    demoAlreadyCompleted: 'Du hast die 10 kostenlosen Fragen in diesem Browser bereits abgeschlossen.',
    demoSeeResults: 'Ergebnis anzeigen',

    // Mock exam
    mockTest: 'MOCK-TEST',
    mockIntro: 'Zeitliche Simulation der EDAIC Part 1: Paper A (Basic Sciences) und Paper B (Clinical Practice).',
    mockRuleQuestions: '60 Fragen mit je bis zu 5 Richtig/Falsch-Aussagen',
    mockRuleScoring: '1 Punkt pro richtig beurteilter Aussage, keine Minuspunkte; eine leere Aussage zählt 0',
    mockRuleFeedback: 'Kein Feedback bis zum Ende der Prüfung',
    mockPaperA: 'Paper A',
    mockPaperATitle: 'Basic Sciences',
    mockPaperATopic1: 'Physiologie',
    mockPaperATopic2: 'Pharmakologie',
    mockPaperATopic3: 'Physik, klinische Messung und Statistik',
    mockPaperB: 'Paper B',
    mockPaperBTitle: 'Clinical Practice',
    mockPaperBTopic1: 'Allgemeine Anästhesie',
    mockPaperBTopic2: 'Regional- und Lokalanästhesie',
    mockPaperBTopic3: 'Spezielle Anästhesie inkl. Schmerz',
    mockPaperBTopic4: 'Intensivmedizin',
    mockPaperBTopic5: 'Innere Medizin',
    mockPaperBTopic6: 'Notfallmedizin',
    mockDuration: 'Dauer',
    mockDurationPaper: '120 Min. (Papier)',
    mockDurationComputer: '90 Min. (computerbasiert)',
    mockStart: 'Prüfung starten',
    mockShortfallTitle: 'Weniger Fragen als vorgesehen',
    mockShortfallLine: '{paper} · {area}: {available} von {requested} verfügbar',
    mockResumeTitle: 'Unbeendete Prüfung',
    mockResumeBody: 'Sie haben eine laufende Prüfung, die noch nicht abgelaufen ist.',
    mockResume: 'Prüfung fortsetzen',
    mockHistory: 'Bisherige Prüfungen',
    mockHistoryEmpty: 'Noch keine abgeschlossene Prüfung.',
    mockSubmitted: 'Abgegeben',
    mockScore: 'Punkte',
    mockResultLink: 'Ergebnis',
    mockRemaining: 'Verbleibende Zeit',
    mockFlag: 'Markieren',
    mockFlagged: 'Markiert',
    mockSubmit: 'Prüfung abschliessen',
    mockSubmitShort: 'Abgeben',
    mockSubmitConfirm: 'Möchten Sie die Prüfung wirklich abgeben?',
    mockPartial: 'Teilweise beantwortet',
    mockAnswered: 'Beantwortet',
    mockNavigator: 'Fragenübersicht',
    mockNavigatorSummary: 'Fragenübersicht ({answered}/{total} beantwortet, {flagged} markiert)',
    mockResultTitle: 'Ergebnis',
    mockPassed: 'Bestanden',
    mockFailed: 'Nicht bestanden',
    mockPassGuide: 'Richtwert {threshold} %; die offizielle ESAIC-Bestehensgrenze variiert jährlich',
    mockAreas: 'Punkte pro Bereich',
    mockArea: 'Bereich',
    mockReview: 'Durchsicht',
    mockYourAnswer: 'Ihre Antwort',
    mockCorrectIs: 'Richtige Antwort',
    mockBlankAnswer: 'Leer',
    mockHint: 'Hinweis',
    mockPoint: 'Punkt',
    mockPoints: 'Punkte',
    mockBack: 'Zurück zum Mock-Test',
    mockTrue: 'Richtig',
    mockFalse: 'Falsch',
    mockLoadError: 'Die Prüfung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    mockSubscriptionTitle: 'Abo erforderlich',
    mockSubscriptionBody: 'Für den Mock-Test ist ein aktives Abo erforderlich.',
    mockSubscriptionKept: 'Ihre bisherigen Antworten bleiben gespeichert.',
    mockSubscribe: 'Abo abschliessen',
    mockSubmitError: 'Die Prüfung konnte nicht abgegeben werden. Bitte versuchen Sie es erneut.',
    mockTimeUp: 'Die Zeit ist abgelaufen. Ihre Antworten werden abgegeben.',
    mockSelectPaper: 'Bitte wählen Sie ein Paper.',
    mockArea_statistics: 'Statistik',
    mockArea_physiology: 'Physiologie',
    mockArea_pharmacology: 'Pharmakologie',
    mockArea_physics: 'Physik und klinische Messung',
    mockArea_general_anaesthesia: 'Allgemeine Anästhesie',
    mockArea_regional_anaesthesia: 'Regional- und Lokalanästhesie',
    mockArea_special_anaesthesia: 'Spezielle Anästhesie',
    mockArea_intensive_care: 'Intensivmedizin',
    mockArea_internal_medicine: 'Innere Medizin',
    mockArea_emergency_medicine: 'Notfallmedizin',
};